import { api } from "@/lib/orgApi";

export const NUCC_SYSTEM = "http://nucc.org/provider-taxonomy";

export async function listPhysicianReferrals({ q, active, category } = {}) {
  const params = {};
  if (q) params.q = q;
  if (active != null) params.active = active;
  if (category) params.category = category;
  const { data } = await api.get("/physician-referrals", { params });
  return data;
}

export async function getPhysicianReferral(referralId) {
  const { data } = await api.get(
    `/physician-referrals/${encodeURIComponent(referralId)}`,
  );
  return data;
}
